import { omitBy, isEmpty, isNil, map } from 'lodash';

const model = (data: any) => {

  const roundingBy2Decimals = (num) => {
    const rounded = parseFloat(Math.round(num * 100) / 100);
    return rounded.toFixed(2);
  }

  const paymentData = {
    subTotal: roundingBy2Decimals(data.paymentDetails.subTotal).toString(),
    shippingFee: roundingBy2Decimals(data.paymentDetails.shippingFee).toString(),
    total: roundingBy2Decimals(data.paymentDetails.total).toString(),
    orderDiscount: roundingBy2Decimals(data.paymentDetails.orderDiscount).toString(),
    shippingDiscount: roundingBy2Decimals(data.paymentDetails.shippingDiscount).toString(),
    discountedSubtotal: roundingBy2Decimals(data.paymentDetails.discountedSubtotal).toString(),
    appliedVouchers: data.paymentDetails.appliedVouchers,
  }

  const shippingAddress = data.shippingAddress ? omitBy({
    type: data.shippingAddress?.type || null,
    street1: data.shippingAddress?.street1 || null,
    street2: data.shippingAddress?.street2 || null,
    city: data.shippingAddress?.city || null,
    state: data.shippingAddress?.state || null,
    postcode: data.shippingAddress?.postcode || null,
    country: data.shippingAddress?.country || null
  }, isNil)
  : null;



  const items = map(data.items, itemObj => {
    return omitBy({
      inventoryID: itemObj.inventoryID,
      quantity: itemObj.quantity,
      uom: itemObj.uom,
      amount: itemObj.amount || null,
      unitPrice: itemObj.unitPrice || null,
      itemType: itemObj.itemType,
      variant: itemObj.variant,
      variantCode: itemObj.variantCode,
      additionalData: itemObj.additionalData || null
    }, isNil)
  })

  return omitBy({
    receiverID: data.receiverID,
    orderedBy: data.orderedBy,
    orderDate: data.orderDate,
    supplierID: data.supplierID,
    orderType: data.orderType || null,
    items: items || null,
    shippingAddress: shippingAddress,
    reqStatus: data.reqStatus,
    paymentDetails: paymentData || null,
    quotationID: data.quotationID ?? undefined,
    remarks: data.remarks || null,
    status: data.status,
    deliveryInfo: data.deliveryInfo,
    orderSource: process.env.ACCOUNT_TYPE
  }, isNil);
}

export default model;
